import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: grid;
  gap: ${theme.spacing.md};
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'text-nf nd-form'
    'ov-bind ov-bind';

  .text-nf {
    grid-area: text-nf;
  }
  .nd-form {
    grid-area: nd-form;
  }
  .ov-bind {
    grid-area: ov-bind;
  }

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    grid-template-columns: 1fr;
    grid-template-areas:
      'text-nf'
      'nd-form'
      'ov-bind';
  }
`
